import React from "react";

function Icon(props) {
	return (
		<svg style={props.style} x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
			<polygon fill="#1A1B1C" points="11,9.585 4.415,3.001 10,3 10,1 1,1 1,10.001 3,10.001 2.999,4.414 9.585,11 	"/>
		</svg>
	)
}

export default {
	none: {
		indicate: () => {
			return [];
		},
		transition: (progress) => {
			return {};
		},
	},
	centerZoomIn: {
		indicate: () => {
			return [
				<Icon key={0} style={{left: '4px', top: '4px'}}/>,
				<Icon key={1} style={{right: '4px', top: '4px', transform: 'rotate(90deg)'}}/>,
				<Icon key={2} style={{right: '4px', bottom: '4px', transform: 'rotate(180deg)'}}/>,
				<Icon key={3} style={{left: '4px', bottom: '4px', transform: 'rotate(-90deg)'}}/>,
			];
		},
		transition: (progress) => {
			let from = 1;
			let to = 1.2;
			let result = from + (to - from) * progress;
			return {transform: 'scale(' + result + ')'};
		},
	},
	centerZoomOut: {
		indicate: () => {
			return [
				<Icon key={0} style={{right: '4px', bottom: '4px'}}/>,
				<Icon key={1} style={{left: '4px', bottom: '4px', transform: 'rotate(90deg)'}}/>,
				<Icon key={2} style={{left: '4px', top: '4px', transform: 'rotate(180deg)'}}/>,
				<Icon key={3} style={{right: '4px', top: '4px', transform: 'rotate(-90deg)'}}/>,
			];
		},
		transition: (progress) => {
			let from = 1.2;
			let to = 1;
			let result = from + (to - from) * progress;
			return {transform: 'scale(' + result + ')'};
		},
	},
	moveToLeft: {
		indicate: () => {
			return [
				<Icon key={0} style={{left: '4px', top: '0', bottom: '0', margin: 'auto', transform: 'rotate(-45deg)'}}/>,
			];
		},
		transition: (progress) => {
			let from = 1;
			let to = 1.2;
			let translate = (to-from) * 100 * progress;
			return {transform: 'translateX(' + -translate + '%) scale(1.4)'};
		},
	},
	moveToRight: {
		indicate: () => {
			return [
				<Icon key={1} style={{right: '4px', top: '0', bottom: '0', margin: 'auto', transform: 'rotate(135deg)'}}/>,
			];
		},
		transition: (progress) => {
			let from = 1;
			let to = 1.2;
			let translate = (to-from) * 100 * progress;
			return {transform: 'translateX(' + translate + '%) scale(1.4)'};
		},
	},
	moveToTop: {
		indicate: () => {
			return [
				<Icon key={0} style={{top: '4px', left: '0', right: '0', margin: 'auto', transform: 'rotate(45deg)'}}/>,
			];
		},
		transition: (progress) => {
			let from = 1;
			let to = 1.2;
			let translate = (to-from) * 100 * progress;
			return {transform: 'translateY(' + -translate + '%) scale(1.4)'};
		},
	},
	moveToBottom: {
		indicate: () => {
			return [
				<Icon key={2} style={{bottom: '4px', left: '0', right: '0', margin: 'auto', transform: 'rotate(-135deg)'}}/>,
			];
		},
		transition: (progress) => {
			let from = 1;
			let to = 1.2;
			let translate = (to-from) * 100 * progress;
			return {transform: 'translateY(' + translate + '%) scale(1.4)'};
		},
	},
}